/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@atlaskit/css';
import { Label, RequiredAsterisk } from '@atlaskit/form';
import { Stack } from '@atlaskit/primitives/compiled';
import Textarea from '@atlaskit/textarea';

type Props = {
	label: string;
	name: string;
	id: string;
	isRequired: boolean;
};

export const TextareaInput = ({ label, name, id, isRequired }: Props): JSX.Element => (
	<Stack space="space.050">
		<Label htmlFor={id}>
			{label}
			{isRequired && <RequiredAsterisk />}
		</Label>
		<Textarea
			name={name}
			id={id}
			isRequired={isRequired}
			isReadOnly
			minimumRows={4}
			resize="smart"
		/>
	</Stack>
);
